import {LANDING} from '@constants/internal-route.constant'
import {useAuth} from '@context/Auth'
import {usePermissions} from '@services/helper/permission.helper'
import {Navigate} from 'react-router-dom'

/**
 * Where the app root ('/') and the portal hand-off ('auth/*') send a signed-in user: the landing
 * page set for their role IN THIS APP on portal's Role Permission screen (verify-token `landing`,
 * resolved server-side for this app's aud), when they can open it; otherwise the Landing page, which forwards to the first screen the user holds.
 *
 * It waits for verify-token, because until it answers `landing` and the grants are the previous
 * session's copy from storage. Only these two entry points use it: RequireFeature's fallback stays
 * the fixed LANDING, so a landing page that was later revoked can never bounce with a guard.
 */
const LandingRedirect = () => {
  const {isChecking, userInfo} = useAuth()
  const {hasFeature} = usePermissions()
  if (isChecking) return null

  const url = userInfo?.landing?.url
  return <Navigate to={url && hasFeature(url) ? url : LANDING} replace />
}

export default LandingRedirect
